/* eslint-disable prefer-const */
import React, { useEffect, useRef, useState } from 'react';
import { form } from '@sitecore-jss/sitecore-jss';
import { useSitecoreContext } from '../enhancers/withSitecoreContext';
let { executeScriptElements, loadForm, subscribeToFormSubmitEvent } = form;
/**
 * Mock function to replace the form module functions for `testing` purposes.
 * @param {any} formModule - The form module to mock
 */
export const mockFormModule = (formModule) => {
    executeScriptElements = formModule.executeScriptElements;
    loadForm = formModule.loadForm;
    subscribeToFormSubmitEvent = formModule.subscribeToFormSubmitEvent;
};
export const Form = ({ params, rendering }) => {
    var _a;
    const id = params === null || params === void 0 ? void 0 : params.RenderingIdentifier;
    const [error, setError] = useState(false);
    const [content, setContent] = useState('');
    const context = useSitecoreContext();
    const formRef = useRef(null);
    const isEditing = context.sitecoreContext.pageEditing;
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!content) {
            loadForm((_b = (_a = context.api) === null || _a === void 0 ? void 0 : _a.edge) === null || _b === void 0 ? void 0 : _b.contextId, params.FormId, (_d = (_c = context.api) === null || _c === void 0 ? void 0 : _c.edge) === null || _d === void 0 ? void 0 : _d.edgeUrl)
                .then(setContent)
                .catch(() => {
                if (isEditing) {
                    console.error(`Failed to load form with id ${params.FormId}. Check debug logs for sitecore-jss:form for more details.`);
                }
                setError(true);
            });
        }
        else {
            // If we are in editing mode, we don't want to send any events
            if (!isEditing) {
                subscribeToFormSubmitEvent(formRef.current, rendering.uid);
            }
            executeScriptElements(formRef.current);
        }
    }, [content]);
    if (isEditing) {
        if (error) {
            return (React.createElement("div", { className: "sc-jss-placeholder-error" }, "There was a problem loading this section"));
        }
    }
    return (React.createElement("div", { ref: formRef, dangerouslySetInnerHTML: { __html: content }, className: (_a = params.styles) === null || _a === void 0 ? void 0 : _a.trimEnd(), id: id ? id : undefined }));
};
